import { useEffect, useState } from "react";
import { FaRegClock } from "react-icons/fa";
import HeaderSection from "../../components/HeaderSection";
import { API_URL } from "../../url/api";
import { isMeetingWithin10Minutes } from "../../utils";

type AppointmentDataProps = {
  count: number;
  next: number | null;
  previous: number | null;
  results: AppointmentProps[];
};

type AppointmentProps = {
  id: number;
  title: string | null;
  room_id: string;
  doctor: {
    id: number;
    name: string;
    email: string;
  };
  schedule_time: {
    id: number;
    date: string;
  };
  time_slot: {
    id: number;
    datetime: string;
  };
  is_paid: boolean;
  session_status: string;
};

function getHumanReadableTime(datetime: string): string {
  const [date, time] = datetime.split("T");
  const [hours, minutes] = time.split(":");

  const formattedTime = new Date(`${date}T${hours}:${minutes}:00`).toLocaleTimeString([], {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  return formattedTime;
}

const AppointmentHistory = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<AppointmentDataProps>();
  const [appointments, setAppointments] = useState<AppointmentProps[]>([]);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      window.location.href = "/signup?type=login";
    } else {
      // ?page=${currentPage}
      fetch(`${API_URL}v2/user/${userId}/appointment/?page=${currentPage}`)
        .then((response) => response.json())
        .then((data) => {
          setData(data);
          setAppointments(data.results);
        })
        .catch((error) => console.error(error));
    }
  }, [currentPage]);

  const handlePageChange = (newPage: number) => setCurrentPage(newPage);

  const pages = Array.from(
    { length: (data?.count || 0) / 10 },
    (_, i) => i + 1
  );

  return (
    <div>
      <HeaderSection />
      <div className="w-full justify-center mt-8 px-4">
        <h2 className="text-2xl font-bold max-w-4xl mb-4 m-auto">
          Appointment History
        </h2>
        <div className="w-full mb-4 max-w-4xl m-auto">
          {/* Render appointments here */}
          {appointments.map((appointment) => (
            <div
              key={appointment.id}
              className="bg-white rounded-lg p-4 px-4 md:px-8 flex items-center shadow-sm mb-4"
            >
              {/* Render appointment details here */}
              <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mr-4">
                <div className="text-center">
                  <div className="text-2xl font-500">
                    {new Date(appointment.time_slot.datetime).getDate()}
                  </div>
                  <div className="text-xs text-red-500">
                    {new Date(appointment.time_slot.datetime).toLocaleString(
                      "default",
                      { month: "short" }
                    )}
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <h3 className="text-lg font-400">
                  {appointment.title || "Speech Therapy"}
                </h3>
                <div className="flex justify-start items-center space-x-2">
                  <FaRegClock />
                  <p className="font-medium text-md">
                    {getHumanReadableTime(
                        appointment.time_slot.datetime
                    )}
                  </p>
                </div>
              </div>
              <div className="ml-auto">
                {isMeetingWithin10Minutes(
                  appointment.time_slot.datetime
                ) ? (
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg"
                    onClick={() => {
                      window.location.href = `/videocall?room_id=${appointment.room_id}`;
                    }}
                  >
                    Join Now
                  </button>
                ) : (
                  <p>{`Completed`}</p>
                )}
              </div>
            </div>
          ))}
          {appointments.length === 0 && (
            <p className="text-center text-md font-medium my-6 text-gray-400">
              No appointments found
            </p>
          )}
        </div>

        <div className="flex justify-center">
          {pages.map((page) => (
            <button
              key={page}
              className={`mx-1 px-3 py-2 rounded-md text-sm font-medium ${
                currentPage === page
                  ? "bg-blue-500 text-white shadow-lg"
                  : "text-blue-700 bg-white shadow-lg"
              }`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppointmentHistory;
